<template lang="pug">
  .new-activity
    .new-activity-steps
      .new-activity-steps__title Новое мероприятие
      .new-activity-steps__content
        .new-activity-steps__steps
          .new-activity-steps__step 1
          .new-activity-steps__step 2
          .new-activity-steps__step.active 3
        .new-activity-steps__text Заведение мероприятия с простой рассадкой может занять всего 5 минут.
          br
          | На этом шаге заполните основную информацию о мероприятии.
    form.form.new-activity-info.new-activity-info--660
      h2.h2.new-activity-info__title Настройки и публикация
      .form__group
        label.form__label Статус мероприятия
        .form__full
          v-select(
              :options="this.status"
              :clearable="false"
              :placeholder="'Выберите статус'"
          ).form__select
              template(v-slot:no-options) Извините, нет подходящих вариантов.
        .form__text Для запуска продаж на ваши мероприятия необходимо заключить договор.
            br
            | Добавьте реквизиты организатора, чтобы начать продавать билеты.
      h3.h3 Организатор
      template(v-if='!organizerVisible')
          a(href="#" @click.prevent='showModal = true').btn Добавить организатора
      template(v-if='organizerVisible')
          .form__text {{ this.organizer }}
              a(href="#" @click.prevent='showModal = true').organizer-link
                svgicon(name="edit" class="svg")

      h3.h3 Где будет видно мероприятие
      label.form__group.form__group--visible
        p-radio(name="visible-activity" v-model="radio" value="На сайте тиво и партнёров" class="input-round p-svg p-round p-pulse" color="primary" required)
          svgicon(name="check" class="svg")
          |На сайте тиво и партнёров
        p-radio(name="visible-activity" v-model="radio" value="Видно только через виджет" class="input-round p-svg p-round p-pulse" color="primary" required)
          svgicon(name="check" class="svg")
          |Видно только через виджет
        span.form__info
          svgicon(name="info" :fill="false")
          .form__info-hidden.form__info-hidden--left Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным

      h3.h3 Отложить старт продаж до
      .form__flex.form__flex--date
        .form__group
            label.form__label Дата старта
            date-picker(v-model="dateStart" format="DD.MM.YYYY" :disabled-date="beforeDateEnd").form__input

        .form__group
            label.form__label Время старта
            v-select(
                :options="hours"
                :clearable="false"
                :searchable="false"
                :placeholder="'00'"
            ).form__select.form__select--mini
            span.points :
            v-select(
                :options="minutes"
                :clearable="false"
                :searchable="false"
                :placeholder="'00'"
            ).form__select.form__select--mini
            span.form__info
              svgicon(name="info" :fill="false")
              .form__info-hidden.form__info-hidden--left Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным
        .form__text Укажите дату и время для временной зоны Москвы (GMT+3)

      h3.h3 Отложить закрытие продаж до
      .form__group
          .form__flex.form__flex--date
            .form__group
                label.form__label Дата завершения
                date-picker(v-model="dateEnd" format="DD.MM.YYYY" :disabled-date="afterDateStart").form__input
            .form__group
                label.form__label Время завершения
                v-select(
                    :options="hours"
                    :clearable="false"
                    :searchable="false"
                    :placeholder="'00'"
                ).form__select.form__select--mini
                span.points :
                v-select(
                    :options="minutes"
                    :clearable="false"
                    :searchable="false"
                    :placeholder="'00'"
                ).form__select.form__select--mini
                span.form__info
                    svgicon(name="info" :fill="false")
                    .form__info-hidden.form__info-hidden--left Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным
            .form__text Укажите дату и время для временной зоны Москвы (GMT+3)

      button(@click.prevent="nextStep()").btn.btn--big.new-activity-info__next Готово

      modal(v-show='showModal' @close='showModal = false')
          h3(slot='header') Добавить организатора
          template(slot='body')
              .form__group
                  label.form__label Название организатора
                  .form__full
                    v-select(
                      :options="['Организатор1', 'Организатор2', 'Организатор3', 'Организатор4']"
                      :clearable="false"
                      :placeholder="'Выберите статус'"
                      v-model='organizer'
                    ).form__select.form__select--full
                      template(v-slot:no-options) Извините, нет подходящих вариантов.
          template(slot='footer')
              button.btn(:class="[{'btn--disabled': !organizer}]" @click.prevent="addOrganizer()") Сохранить

</template>

<script>
import Modal from '@/components/Modal.vue'
import { mapGetters } from 'vuex';
export default {
  name: 'NewActivity',
  components:{
    Modal,
  },
  data() {
    return {
      radio: null,
      dateStart: null,
      dateEnd: null,
      organizer: null,
      organizerVisible: false,
      showModal: false,
      status: [
        'Планируется (черновик)',
        'Скрыто',
        'Активно'
      ]
    }
  },
  methods: {
    nextStep: function(){
      if(this.validation) {
        return this.$router.push({ name: 'preview' })
      }
    },
    beforeDateEnd(date) {
      if (this.dateEnd != null)
      return date > this.dateEnd;
    },
    afterDateStart(date) {
      if (this.dateStart != null)
      return date < this.dateStart;
    },
    addOrganizer() {
      if(this.organizer) {
          this.organizerVisible = true
          this.showModal = false
      }
    }
  },
  computed: {
    ...mapGetters([
      'hours',
      'minutes',
      'cities',
      'activityPlace',
    ]),
    validation() {
      let valid = false;
      if(!!this.radio && !!this.dateStart && !!this.dateEnd) {
        valid = true;
      } else {
        valid = false;
      }
      return valid;
    }
  }
}
</script>

<style lang="scss">
.new-activity-steps{
  padding: 40px 40px;
  background-color: #008cff;
  background-image: linear-gradient(to right, #008cff 0%, #b533eb 100%);
  &__title{
    color: #fff;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  &__content{
    display: flex;
  }
  &__steps{
    display: flex;
    margin-right: 35px;
  }
  &__step{
    width: 50px;
    height: 50px;
    border: 1px solid rgba(#fff, 0.5);
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 26px;
    margin-right: 20px;
    border-radius: 50%;
    &.active{
      background-color: #fff;
      border-color: #fff;
      color: #161616;
    }
  }
  &__text{
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: 25px;
  }
}
.new-activity-info{
  &--660{
    padding: 0px 40px;
    margin: 30px 0 40px;
    max-width: 660px;
  }
  &__content{
    display: flex;
    margin-bottom: 20px;
  }
  &__left{
    margin-right: 85px;
    width: 640px;
  }
}
.form{
  &__flex{
    &--vcenter{
      align-items: center;
    }
    &--date{
      .form__input{
        width: 132px;
        margin-right: 5px;
        padding: 0;
        border: none;
      }
    }
  }
  &__tickets{
    .form__group{
      margin-right: 30px;
    }
  }
  &__group{
    &--age{
      position: relative;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 20px;
      margin-bottom: 0;
      background: #e7f1f8;
      text-align: center;
      line-height: 50px;
      color: #161616;
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      input{
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
      &:nth-last-child(2){
        margin-right: 0;
      }
      &.checked{
        background-color: #008cff;
        color: #fff;
        cursor: default;
      }
      &:hover{
        background-color: #008cff;
        color: #fff;
      }
    }
    &--online{
      cursor: pointer;
      color: #161616;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 20px;
      display: inline-block;
      input{
        margin-right: 10px;
      }
      & + h3{
          margin-top: 0;
      }
    }
  }
}
.points{
  display: inline-block;
  vertical-align: top;
  color: #161616;
  font-size: 16px;
  font-weight: 600;
  line-height: 37px;
}
.defis{
  margin: 0 7px;
  color: #161616;
  font-size: 16px;
  font-weight: 600;
  line-height: 25px;
}
.noarea{
  display: flex;
  align-items: center;
  &__text{
    color: #161616;
    font-size: 14px;
    line-height: 20px;
    margin-right: 20px;
  }
}
.image-form{
  background-color: #e7f1f8;
  padding: 20px 30px;
  display: flex;
  margin-bottom: 30px;
  max-width: 440px;
  &__ava{
    width: 110px;
    height: 110px;
    margin-right: 20px;
    border-radius: 50%;
    overflow: hidden;
    img{
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__info{
    align-self: center;
  }
  &__title{
    color: #161616;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
    display: flex;
    align-items: flex-end;
  }
}
.organizer-link{
    width: 23px;
    height: 23px;
    margin-left: 15px;
    color: #008cff;
    display: inline-block;
    .svg-icon{
        width: 100%;
        height: 100%;
    }
    &:hover{
        color: #026ac0;
    }
}
@media (max-width: 1339px) {
  .new-activity-info__left {
    margin-right: 30px;
    flex-shrink: 0;
  }
}
@media (max-width: 1199px) {
  .new-activity-info__left {
    width: 450px;
  }
  .defis{
    display: none;
  }
  .form__flex--date{
    flex-direction: column;
    .form__group{
      width: 100%;
    }
    .form__input{
      width: calc(100% - 185px);
    }
  }
}
@media (max-width: 991px) {
  .new-activity-info{
    padding: 0 20px;
  }
  .new-activity-info__content{
    flex-direction: column;
  }
  .new-activity-info__left{
    width: 100%;
    margin-right: 0;
    margin-bottom: 30px;
  }
}
@media (max-width: 767px) {
  .new-activity-steps__content{
    flex-direction: column;
  }
  .new-activity-steps__steps{
    margin-bottom: 20px;
    margin-right: 0;
  }
  .new-activity-steps__text{
    font-size: 14px;
    line-height: 20px;
  }
  .new-activity-info{
    padding: 0 20px;
  }
  .new-activity-steps{
    padding: 20px;
  }
  .form__group--age{
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
@media (max-width: 479px) {
  .form__flex--date .form__input {
    width: calc(100% - 31px);
    margin-right: 0;
    margin-bottom: 15px;
  }
  .form__select--mini {
    width: calc(50% - 25px);
  }
  .image-form{
    padding: 20px;
    flex-direction: column;
  }
  .image-form__ava{
    margin-right: 0;
    margin-bottom: 20px;
  }
  .image-form__info{
    align-self: flex-start;
  }
}
</style>